var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 28.8,
    height: 28.8,
    rx: 2.4,
    stroke: "#F8F7ED",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99995 8.39941C7.67446 8.39941 6.59995 9.47393 6.59995 10.7994V19.1994C6.59995 20.5249 7.67446 21.5994 8.99995 21.5994H21.5999C22.9254 21.5994 23.9999 20.5249 23.9999 19.1994V10.7994C23.9999 9.47393 22.9254 8.39941 21.5999 8.39941H8.99995ZM7.79995 10.7994C7.79995 10.1367 8.3372 9.59941 8.99995 9.59941H21.5999C22.2627 9.59941 22.7999 10.1367 22.7999 10.7994V19.1994C22.7999 19.8622 22.2627 20.3994 21.5999 20.3994H8.99995C8.3372 20.3994 7.79995 19.8622 7.79995 19.1994V10.7994ZM10.8599 11.2194C10.5949 11.0206 10.2188 11.0743 10.0199 11.3394C9.82113 11.6045 9.87485 11.9806 10.1399 12.1794L14.1962 15.2216C14.8529 15.7142 15.7597 15.7 16.4007 15.1872L20.1748 12.1679C20.4335 11.9609 20.4755 11.5834 20.2685 11.3246C20.0615 11.0658 19.6839 11.0239 19.4251 11.2309L15.6511 14.2502C15.4374 14.4211 15.1351 14.4258 14.9162 14.2616L10.8599 11.2194Z",
    fill: "#F8F7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.28a926b717e481f6169c87edf543c434.svg";
export { ForwardRef as ReactComponent };